import { render, staticRenderFns } from "./CalendarBody.vue?vue&type=template&id=5f43d0f5&"
import script from "./CalendarBody.vue?vue&type=script&lang=js&"
export * from "./CalendarBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports